import React from 'react';
import styled from 'styled-components';

const Info = styled.div`
  font-size: 13px;
  margin-bottom: 16px;
  color: var(--subTextColor);
  line-height: 1.5;
`;

const DEFAULT_TEXT: Record<'list' | 'grid', string> = {
  list: '⚙️ 드래그, 드롭으로 순서 이동 가능. 약 0.5초 정도 꾹 누른 후, 이동 가능합니다.',
  grid: '⚙️ 아이템을 드래그해 슬롯에 배치할 수 있습니다. 우클릭(모바일: 더블탭) 시 미정리 아이템으로 돌아갑니다.',
};

type Props = {
  variant?: 'list' | 'grid';
  text?: string;
};
function DragDropInfo({ variant = 'list', text }: Props) {
  return <Info>{text ?? DEFAULT_TEXT[variant]}</Info>;
}

export default DragDropInfo;
